export default "__VITE_ASSET__DdtGmSNA__"